import { ExportOption } from '../../../../shared/selection-button/selection-option';
import { IconType } from '../../../../shared/custom-icon/custom-icon';

export const ExportOptions: ExportOption[] = [
    {
        key: 'xlsx',
        label: 'Excel',
        exportAllLabel: 'Excel',
        icon: IconType.EXPORT_EXCEL
    },
    {
        key: 'csv',
        label: 'Comma Delimiter (.csv)',
        exportAllLabel: 'CSV',
        icon: IconType.EXPORT_CSV
    },
    {
        key: 'json',
        label: 'JSON (.json)',
        exportAllLabel: 'JSON',
        icon: IconType.EXPORT_JSON
    }
];